import { call, put } from 'redux-saga/effects';

import {
  removeCustomPlaylist,
  setCustomPlaylists,
  setCustomPlaylistsError,
  setCustomPlaylistsLoading,
} from '../actions/customAudioPlaylistActions';
import {
  deleteCustomPlaylist,
  getCustomPlaylists,
} from '../services/customAudioPlaylistService';

export function* getCustomPlaylistsSaga() {
  try {
    yield put(setCustomPlaylistsLoading(true));
    yield put(setCustomPlaylistsError(''));
    const playlists = yield call(getCustomPlaylists);
    yield put(setCustomPlaylists(playlists));
  } catch (error) {
    yield put(setCustomPlaylistsError('Error loading custom playlists'));
  } finally {
    yield put(setCustomPlaylistsLoading(false));
  }
}

export function* deleteCustomPlaylistSaga(action) {
  try {
    yield call(deleteCustomPlaylist, action.playlistId);
    yield put(removeCustomPlaylist(action.playlistId));
  } catch (error) {
    yield put(setCustomPlaylistsError('Error deleting playlist'));
  }
}
